import { TABLE_HEADER_HEIGHT } from 'foundations-components/transitional/constants';
// FDT intentionally keeps headers denser than foundations' standard
// TABLE_HEADER_HEIGHT (40px) to preserve CRM index/table density.
export const CUSTOM_TABLE_HEADER_HEIGHT = '40px';
export const DEFAULT_COLUMN_MINIMUM_WIDTH = 100;
export const MINIMUM_RESIZABLE_COLUMN_WIDTH = 60;
export const DEFAULT_COLUMN_WIDTH = 250;
export const SELECTION_COLUMN_WIDTH = 45;
export const TABLE_TOP_BAR_HEIGHT = TABLE_HEADER_HEIGHT;
export const TABLE_PAGINATOR_HEIGHT = 40;
export const TABLE_ROW_HEIGHT = 40;
export const TABLE_RIGHT_TOOLBAR_WIDTH = 32;
export const TABLE_COLLAPSED_TOOLBAR_WIDTH = 12;
// Maps each density to the corresponding Trellis space token and its current
// pixel value. The virtualizer needs a numeric estimate *before* the row is
// rendered, so we hardcode the pixel sizes here. If the Trellis token values
// ever change these must be updated to match.
export const TABLE_ROW_HEIGHT_BY_DENSITY = {
  small: {
    pixels: 32,
    spaceToken: '800'
  },
  medium: {
    pixels: TABLE_ROW_HEIGHT,
    spaceToken: '1000'
  },
  large: {
    pixels: 56,
    spaceToken: '1200'
  }
};
// The min-content non-empty table consists of the header plus one row
export const TABLE_NON_EMPTY_MIN_CONTENT_HEIGHT = parseInt(CUSTOM_TABLE_HEADER_HEIGHT, 10) + TABLE_ROW_HEIGHT;